import { render, staticRenderFns } from "./emailElementEditor.vue?vue&type=template&id=580d9ef1&scoped=true&"
import script from "./emailElementEditor.vue?vue&type=script&lang=js&"
export * from "./emailElementEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d9ef1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VHover})
